import { api } from "./Api";

export interface ICountry {
  id: string;
  name: string;
  shortName: string;
}

export interface IRestCountries {
  data: {
    code: number;
    message: string;
    pagination: { offset: number; limit: number; total: number };
    data: ICountry[];
  };
}

/**
 * Lista os países cadastrados — alimenta o select de país do banner.
 *
 * Sem toast: a lista carrega junto com a tela e um erro aqui não deve
 * atrapalhar quem só quer editar o nome do banner. Quem chama trata a falha
 * mantendo o select vazio.
 */
export const getCountries = async (): Promise<ICountry[]> => {
  const response = (await api.get(`/pt_BR/countries`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: "json",
  })) as IRestCountries;

  return response.data.data ?? [];
};